import _defineProperty from "/home/runner/work/freeCodeCamp/freeCodeCamp/node_modules/.pnpm/@babel+runtime@7.27.3/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Parser } from "../Parser.js";
export class EraParser extends Parser {
  constructor() {
    super(...arguments);
    _defineProperty(this, "priority", 140);
    _defineProperty(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(dateString, token, match) {
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return match.era(dateString, {
          width: "abbreviated"
        }) || match.era(dateString, {
          width: "narrow"
        });

      // A, B
      case "GGGGG":
        return match.era(dateString, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return match.era(dateString, {
          width: "wide"
        }) || match.era(dateString, {
          width: "abbreviated"
        }) || match.era(dateString, {
          width: "narrow"
        });
    }
  }
  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}